import { Injectable } from '@angular/core';
import { URL_BASE } from '../../core/constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtils } from '../http-utils';
import { EmbeddedToken } from '../embeddedToken.model';
import { PowerBiReport } from '../power-bi-report.model';
import { map } from 'rxjs/operators';

@Injectable()
export class PowerBiReportService {

  private apiUrl = `${URL_BASE}/api/power-bi-reports`;

  constructor(private http: HttpClient) {
  }

  public getReportToken(reportId: string): Observable<EmbeddedToken> {
    const headers = HttpUtils.createHeaders();
    return this.http.get(`${this.apiUrl}/${reportId}/token`, {headers})
      .pipe(
        map(e => EmbeddedToken.fromDto(e))
      );
  }

  public getPowerBiReports(): Observable<PowerBiReport[]> {
    const headers = HttpUtils.createHeaders();
    return this.http.get(`${this.apiUrl}`, {headers})
      .pipe(
        map((result: any[]) => result.map(e => PowerBiReport.fromDto(e)))
      );
  }

  public getPowerBiReportById(reportId: string): Observable<PowerBiReport> {
    const headers = HttpUtils.createHeaders();
    return this.http.get(`${this.apiUrl}/${reportId}`, {headers})
      .pipe(
        map(c => PowerBiReport.fromDto(c))
      );
  }

}
